import { Injectable, Injector } from '@angular/core';
import { MarsHttpDataService } from 'app/mars/services/mars-http-data.service';

@Injectable()
export class MarsMessagesService extends MarsHttpDataService {
  constructor(protected injector: Injector) {
    super(injector, '');
  }

  getFetchUrl() {
    return `${this.baseUrl}/admin/messages`;
  }

  create(props: any) {
    const url = `${this.baseUrl}/activities/humanResorcesMessage`;

    return this.postRequest(url, JSON.stringify(props), this.getRequestOptions());
  }
}
